export default {
  async loadActiveDevices(context, payload ) {

    var token = context.rootGetters['auth/getToken']
    var bearer_token = "Bearer " + token;
    var apiUrl = context.rootGetters['config/getApiUrl']
    var url = `${apiUrl}/activedevices`;

    const response = await fetch(url, {
        method: "GET",
        headers: {
        Authorization: bearer_token,
        "Content-Type": "application/json",
        },
    });
    if (!response.ok) {
        //error, NOT ok
        const error = new Error(responseData.message || "Failed to fetch.");
        throw error;
    }
    const responseJson = await response.json();
    const responseData = [];

    for (const key in responseJson) {
        // console.log("loadActiveDevices", responseJson[key])
        const device = {
          deviceId: responseJson[key].deviceId,
          // status: responseJson[key].status,
          imei: responseJson[key].imei,

          manufacturer: responseJson[key].manufacturerName,
          usageType: responseJson[key].usageTypeName,
          deviceType: responseJson[key].deviceTypeName,
          containerId: responseJson[key].containerId,
          containerType: responseJson[key].containerTypeName,
          operator: responseJson[key].operatorName,
          area: responseJson[key].areaName,
          office: responseJson[key].officeName,
          district: responseJson[key].districtName,
          containerName: responseJson[key].containerName,
          alias: responseJson[key].containerProperties.alias,
          downholeLSD: responseJson[key].containerProperties['downhole lsd'],
          product: responseJson[key].containerProperties.product,
          satellite: responseJson[key].containerProperties['satellite connection'],
          model: responseJson[key].containerProperties.model,
          // contractId: responseJson[key].contractId,
          contractName:responseJson[key].contractName,
          contractDate:responseJson[key].contractDate,
          installDate:responseJson[key].installDate,
          latitude: responseJson[key].latitude,
          longitude: responseJson[key].longitude,
        };
        responseData.push(device);
    }
    // console.log('loadActiveDevices',responseData)
    context.commit('setActiveDevices', responseData)
  },
  
  async loadDevicesByContainer(context, payload ) {
    var token = context.rootGetters['auth/getToken']
    var bearer_token = "Bearer " + token;
    var apiUrl = context.rootGetters['config/getApiUrl']
    var url = `${apiUrl}/devices/bycontainer/${payload}`;

    const response = await fetch(url, {
        method: "GET",
        headers: {
        Authorization: bearer_token,
        "Content-Type": "application/json",
        },
    });
    if (!response.ok) {
        //error, NOT ok
        const error = new Error("Failed to fetch.");
        throw error;
    }
    const responseJson = await response.json();
    
    context.commit('setContainerDevices', responseJson)
  },
  async updateDevicesByContainer(context, payload ) {
    var token = context.rootGetters['auth/getToken']
    var bearer_token = "Bearer " + token;
    var apiUrl = context.rootGetters['config/getApiUrl']
    var url = `${apiUrl}/devices`;
    
    // console.log("UPDATE", payload[0])
    const response = await fetch(url, {
      method: 'PUT',
      headers: {
        Authorization: bearer_token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload[0])
    });

    if (!response.ok) {
      //const error = new Error(responseData.message || 'Failed to send request.');
      const error = new Error('Failed to send request.');
      throw error;
    }

  },
};